import { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { requestPasswordResetAPI } from '../api/auth';
import Logo from '../components/ui/Logo';

export default function PasswordDimenticataPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) {
      setError(t('auth.reset.inserisci_email'));
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await requestPasswordResetAPI(email.trim());
      setSent(true);
    } catch (err: unknown) {
      // Email malformata → 422 di validazione: messaggio inline, nessun leak.
      if (axios.isAxiosError(err) && err.response?.status === 422) {
        setError(t('auth.reset.email_non_valida'));
      } else {
        setError(t('auth.reset.errore_generico'));
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-stone-bg flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-md border border-stone-mid overflow-hidden">
          <div className="flex justify-center py-6 border-b border-stone-mid px-6">
            <Logo width={140} />
          </div>

          {sent ? (
            <div className="px-6 py-8 text-center">
              <h1 className="text-lg font-semibold text-ink-dark mb-2">
                {t('auth.reset.controlla_email_titolo')}
              </h1>
              <p className="text-sm text-ink-soft mb-6">
                {t('auth.reset.controlla_email_testo')}
              </p>
              <a
                href="/login"
                className="inline-block px-4 py-2 text-sm font-medium text-white bg-sage rounded-lg hover:bg-[#5C6F59] transition-colors"
              >
                {t('auth.reset.torna_al_login')}
              </a>
            </div>
          ) : (
            <div className="px-6 py-6">
              <h1 className="text-lg font-semibold text-ink-dark mb-1">
                {t('auth.reset.titolo')}
              </h1>
              <p className="text-sm text-ink-soft mb-5">
                {t('auth.reset.sottotitolo')}
              </p>

              <form onSubmit={handleSubmit} className="space-y-4" noValidate>
                <div>
                  <label className="block text-sm font-medium text-ink-dark mb-1">
                    {t('auth.login.label_email')} <span className="text-accent-danger">*</span>
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (error) setError(null);
                    }}
                    required
                    autoComplete="email"
                    className="w-full px-3 py-2 text-sm border border-stone-border rounded-lg focus:outline-none focus:ring-2 focus:ring-sage/40 focus:border-sage"
                  />
                </div>

                {error && (
                  <div className="px-3 py-2 bg-accent-danger-bg border border-[#FECACA] rounded text-sm text-accent-danger">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-2.5 px-4 text-sm font-semibold text-white bg-sage rounded-lg hover:bg-[#5C6F59] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {submitting ? t('auth.reset.invio_in_corso') : t('auth.reset.invia_link')}
                </button>

                <div className="text-center">
                  <a
                    href="/login"
                    className="text-[13px] text-sage font-medium hover:underline"
                  >
                    {t('auth.reset.torna_al_login')}
                  </a>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
